import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'

export function AdminPage() {
  const { token } = useAuth()
  const [data, setData] = useState<any>(null)

  useEffect(() => {
    api('/api/admin/overview', { token }).then(setData).catch(console.error)
  }, [token])

  if (!data) return <div className="panel">Loading ops…</div>

  return (
    <div className="stack">
      <div className="panel">
        <h2>Operations</h2>
        <p className="muted">Disputes, receipts, and settlement status for the friend group.</p>
        <span className="chip">Users {data.userCount}</span>
      </div>
      <div className="grid two">
        <div className="panel">
          <h2>Disputes</h2>
          {!data.disputes?.length ? (
            <p className="muted">No open disputes</p>
          ) : (
            <ul className="list">
              {data.disputes.map((d: any) => (
                <li key={d.id}>
                  <div>
                    <strong>{d.reason}</strong>
                    <div className="muted">
                      {d.target_type}:{d.target_id} · {d.status}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="panel">
          <h2>Receipts</h2>
          {!data.receipts?.length ? (
            <p className="muted">No receipts yet</p>
          ) : (
            <ul className="list">
              {data.receipts.map((r: any) => (
                <li key={r.id}>
                  <div>
                    <strong className={r.status === 'complete' ? 'status-good' : 'status-warn'}>
                      {r.status}
                    </strong>
                    <div className="muted">pool {String(r.pool_id).slice(0, 8)}…</div>
                  </div>
                  <span className="chip">{r.receipt_hash?.slice(0, 8)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}
